import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Group, Table, Text, ThemeIcon } from '@mantine/core';
import { IconCheck, IconEdit, IconMinus, IconTrash } from '@tabler/icons-react';

import { useRemoveBotPage } from '../../../api/removePage';
import { SUB_DEPARTMENTS } from '../../../constants';
import { botTypes } from '../../../types';
import { EditModal } from '../EditModal';

import { AppPagesCell } from './AppPagesCell';

import { ConfirmModal } from '@/components/Modals/Confirm';
import { InstPage, TgPage } from '@/features/pages';
import { Departments } from '@/types';

const BoolCell = ({ value }: { value?: boolean }) => (
  <Group justify="center">
    <ThemeIcon size="sm" radius="xl" variant="light" color={value ? 'teal' : 'gray'}>
      {value ? <IconCheck size={14} /> : <IconMinus size={14} />}
    </ThemeIcon>
  </Group>
);

type BodyRowProps = {
  department: Departments;
  page: botTypes.Page;
  pagesMap: Map<string, TgPage | InstPage>;
};

export const BodyRow = ({ department, page, pagesMap }: BodyRowProps) => {
  const removePage = useRemoveBotPage();
  const { _id, name, externalId, subDepartment, appPages, isExpert, isMandatoryManagerSelect } =
    page;

  const handleEdit = () =>
    NiceModal.show(EditModal, {
      page: {
        _id,
        name,
        externalId,
        department,
        subDepartment,
        appPages,
        isExpert,
        isMandatoryManagerSelect,
      },
    });

  const handleRemove = () =>
    NiceModal.show(ConfirmModal, {
      title: `Remove page (${name})?`,
      onSuccess: () => removePage.mutate({ _id }),
    });

  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{name}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{externalId}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{SUB_DEPARTMENTS[subDepartment]}</Text>
      </Table.Td>
      <Table.Td>
        <AppPagesCell pageIds={appPages} pagesMap={pagesMap} />
      </Table.Td>
      <Table.Td ta="center">
        <BoolCell value={isExpert} />
      </Table.Td>
      <Table.Td ta="center">
        <BoolCell value={isMandatoryManagerSelect} />
      </Table.Td>
      <Table.Td style={{ whiteSpace: 'nowrap', width: 1 }}>
        <Group wrap="nowrap" gap="xs">
          <ActionIcon variant="filled" radius="md" onClick={handleEdit}>
            <IconEdit size={16} />
          </ActionIcon>
          <ActionIcon variant="filled" radius="md" color="red" onClick={handleRemove}>
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
};
